import { all } from 'redux-saga/effects'

import activitiesSaga from './components/Blocks/Activities/saga'
import addressesSaga from './components/Blocks/Addresses/saga'
import alzaScoringSaga from './components/Blocks/AlzaScoring/saga'
import annotationsSaga from './components/Blocks/Anotace/saga'
import bisnodeCertificatesSaga from './components/Blocks/BisnodeCertificates/saga'
import bisnodeScoringSaga from './components/BisnodeScoring/saga'
import businessPartnersSaga from './components/Blocks/BusinessPartners/saga'
import certificatesSaga from './components/Blocks/Certificates/saga'
import companyAsCreditorSaga from './components/Blocks/CompanyAsCreditor/saga'
import contactsSaga from './components/Blocks/Contacts/saga'
import contractsSaga from './components/Blocks/Contracts/saga'
import grantsSaga from './components/Blocks/Grants/saga'
import inspectionsSaga from './components/Blocks/Inspections/saga'
import liensSaga from './components/Blocks/Liens/saga'
import negativeEventsSaga from './components/Blocks/NegativeEvents/saga'
import ownershipSaga from './components/Blocks/Ownership/saga'
import paymentComparisonSaga from './components/Blocks/PaymentComparison/saga'
import paymentIndexSaga from './components/PaymentInformations/saga'
import personsSaga from './components/Blocks/Persons/saga'
import procurementSaga from './components/Blocks/Procurement/saga'
import registrationInformationSaga from './components/Blocks/RegistrationInformation/saga'
import rolesSaga from './components/Blocks/RolesInCompanies/saga'
import sizeSaga from './components/Blocks/Velikost/saga'
import syntheticIndicatorsSaga from './components/Signals/saga'
import estatesSaga from './components/Blocks/Estates/saga'

export default function* reportSaga() {
    yield all([
        activitiesSaga(),
        addressesSaga(),
        alzaScoringSaga(),
        annotationsSaga(),
        bisnodeCertificatesSaga(),
        bisnodeScoringSaga(),
        businessPartnersSaga(),
        certificatesSaga(),
        companyAsCreditorSaga(),
        contactsSaga(),
        contractsSaga(),
        grantsSaga(),
        inspectionsSaga(),
        liensSaga(),
        negativeEventsSaga(),
        ownershipSaga(),
        paymentComparisonSaga(),
        paymentIndexSaga(),
        personsSaga(),
        procurementSaga(),
        registrationInformationSaga(),
        rolesSaga(),
        sizeSaga(),
        syntheticIndicatorsSaga(),
        estatesSaga(),
    ])
}
